<template>
    <div style="margin-top: 46px">
        <ul class="d-flex flex-wrap medium">
            <li class="info-link">
                <a href="https://affinitylearning.ca/" rel="noopener" target="_blank" class="text-secondary"
                    >About</a
                >
            </li>
            <li class="info-link">
                <a href="/accessibility" target="_blank" class="text-secondary">Accessibility</a>
            </li>
            <li class="info-link">
                <a href="/legal" target="_blank" class="text-secondary">Legal</a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "InfoFooters",
}
</script>

<style lang="scss" scoped>
ul {
    margin-bottom: 0px;
    padding-inline-start: 0px;
    li {
        list-style-type: none;
    }
}

.info-link {
    margin-right: 18px;
}
</style>